// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/profile/v1/profile_api.proto (package gdx.profile.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ProfileInfo, ProfileLocation, ProfilePreview, ProfileTagsView } from "../../common/v1/profile_pb.js";

/**
 * @generated from message gdx.profile.v1.BatchGetProfileInfoRequest
 */
export class BatchGetProfileInfoRequest extends Message<BatchGetProfileInfoRequest> {
  /**
   * @generated from field: repeated string user_id = 1;
   */
  userId: string[] = [];

  constructor(data?: PartialMessage<BatchGetProfileInfoRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.profile.v1.BatchGetProfileInfoRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetProfileInfoRequest {
    return new BatchGetProfileInfoRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetProfileInfoRequest {
    return new BatchGetProfileInfoRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetProfileInfoRequest {
    return new BatchGetProfileInfoRequest().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetProfileInfoRequest | PlainMessage<BatchGetProfileInfoRequest> | undefined, b: BatchGetProfileInfoRequest | PlainMessage<BatchGetProfileInfoRequest> | undefined): boolean {
    return proto3.util.equals(BatchGetProfileInfoRequest, a, b);
  }
}

/**
 * @generated from message gdx.profile.v1.BatchGetProfileInfoResponse
 */
export class BatchGetProfileInfoResponse extends Message<BatchGetProfileInfoResponse> {
  /**
   * Map key is user id.
   *
   * @generated from field: map<string, gdx.common.v1.ProfileInfo> profiles = 1;
   */
  profiles: { [key: string]: ProfileInfo } = {};

  constructor(data?: PartialMessage<BatchGetProfileInfoResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.profile.v1.BatchGetProfileInfoResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profiles", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: ProfileInfo} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetProfileInfoResponse {
    return new BatchGetProfileInfoResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetProfileInfoResponse {
    return new BatchGetProfileInfoResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetProfileInfoResponse {
    return new BatchGetProfileInfoResponse().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetProfileInfoResponse | PlainMessage<BatchGetProfileInfoResponse> | undefined, b: BatchGetProfileInfoResponse | PlainMessage<BatchGetProfileInfoResponse> | undefined): boolean {
    return proto3.util.equals(BatchGetProfileInfoResponse, a, b);
  }
}

/**
 * @generated from message gdx.profile.v1.GetProfilePreviewRequest
 */
export class GetProfilePreviewRequest extends Message<GetProfilePreviewRequest> {
  /**
   * If empty user_id will be taken from current context. Request context should be authorized.
   *
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<GetProfilePreviewRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.profile.v1.GetProfilePreviewRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProfilePreviewRequest {
    return new GetProfilePreviewRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProfilePreviewRequest {
    return new GetProfilePreviewRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProfilePreviewRequest {
    return new GetProfilePreviewRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetProfilePreviewRequest | PlainMessage<GetProfilePreviewRequest> | undefined, b: GetProfilePreviewRequest | PlainMessage<GetProfilePreviewRequest> | undefined): boolean {
    return proto3.util.equals(GetProfilePreviewRequest, a, b);
  }
}

/**
 * @generated from message gdx.profile.v1.GetProfilePreviewResponse
 */
export class GetProfilePreviewResponse extends Message<GetProfilePreviewResponse> {
  /**
   * @generated from field: gdx.common.v1.ProfilePreview profile = 1;
   */
  profile?: ProfilePreview;

  constructor(data?: PartialMessage<GetProfilePreviewResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.profile.v1.GetProfilePreviewResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile", kind: "message", T: ProfilePreview },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProfilePreviewResponse {
    return new GetProfilePreviewResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProfilePreviewResponse {
    return new GetProfilePreviewResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProfilePreviewResponse {
    return new GetProfilePreviewResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetProfilePreviewResponse | PlainMessage<GetProfilePreviewResponse> | undefined, b: GetProfilePreviewResponse | PlainMessage<GetProfilePreviewResponse> | undefined): boolean {
    return proto3.util.equals(GetProfilePreviewResponse, a, b);
  }
}

/**
 * @generated from message gdx.profile.v1.BatchGetProfilePreviewRequest
 */
export class BatchGetProfilePreviewRequest extends Message<BatchGetProfilePreviewRequest> {
  /**
   * @generated from field: repeated string user_id = 1;
   */
  userId: string[] = [];

  constructor(data?: PartialMessage<BatchGetProfilePreviewRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.profile.v1.BatchGetProfilePreviewRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetProfilePreviewRequest {
    return new BatchGetProfilePreviewRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetProfilePreviewRequest {
    return new BatchGetProfilePreviewRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetProfilePreviewRequest {
    return new BatchGetProfilePreviewRequest().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetProfilePreviewRequest | PlainMessage<BatchGetProfilePreviewRequest> | undefined, b: BatchGetProfilePreviewRequest | PlainMessage<BatchGetProfilePreviewRequest> | undefined): boolean {
    return proto3.util.equals(BatchGetProfilePreviewRequest, a, b);
  }
}

/**
 * @generated from message gdx.profile.v1.BatchGetProfilePreviewResponse
 */
export class BatchGetProfilePreviewResponse extends Message<BatchGetProfilePreviewResponse> {
  /**
   * Map key is user id.
   *
   * @generated from field: map<string, gdx.common.v1.ProfilePreview> profiles = 1;
   */
  profiles: { [key: string]: ProfilePreview } = {};

  constructor(data?: PartialMessage<BatchGetProfilePreviewResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.profile.v1.BatchGetProfilePreviewResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profiles", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: ProfilePreview} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetProfilePreviewResponse {
    return new BatchGetProfilePreviewResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetProfilePreviewResponse {
    return new BatchGetProfilePreviewResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetProfilePreviewResponse {
    return new BatchGetProfilePreviewResponse().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetProfilePreviewResponse | PlainMessage<BatchGetProfilePreviewResponse> | undefined, b: BatchGetProfilePreviewResponse | PlainMessage<BatchGetProfilePreviewResponse> | undefined): boolean {
    return proto3.util.equals(BatchGetProfilePreviewResponse, a, b);
  }
}

/**
 * @generated from message gdx.profile.v1.BatchGetProfileTagsRequest
 */
export class BatchGetProfileTagsRequest extends Message<BatchGetProfileTagsRequest> {
  /**
   * @generated from field: repeated string user_id = 1;
   */
  userId: string[] = [];

  constructor(data?: PartialMessage<BatchGetProfileTagsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.profile.v1.BatchGetProfileTagsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetProfileTagsRequest {
    return new BatchGetProfileTagsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetProfileTagsRequest {
    return new BatchGetProfileTagsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetProfileTagsRequest {
    return new BatchGetProfileTagsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetProfileTagsRequest | PlainMessage<BatchGetProfileTagsRequest> | undefined, b: BatchGetProfileTagsRequest | PlainMessage<BatchGetProfileTagsRequest> | undefined): boolean {
    return proto3.util.equals(BatchGetProfileTagsRequest, a, b);
  }
}

/**
 * @generated from message gdx.profile.v1.BatchGetProfileTagsResponse
 */
export class BatchGetProfileTagsResponse extends Message<BatchGetProfileTagsResponse> {
  /**
   * Map key is user id.
   *
   * @generated from field: map<string, gdx.common.v1.ProfileTagsView> profiles = 1;
   */
  profiles: { [key: string]: ProfileTagsView } = {};

  constructor(data?: PartialMessage<BatchGetProfileTagsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.profile.v1.BatchGetProfileTagsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profiles", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: ProfileTagsView} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetProfileTagsResponse {
    return new BatchGetProfileTagsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetProfileTagsResponse {
    return new BatchGetProfileTagsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetProfileTagsResponse {
    return new BatchGetProfileTagsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetProfileTagsResponse | PlainMessage<BatchGetProfileTagsResponse> | undefined, b: BatchGetProfileTagsResponse | PlainMessage<BatchGetProfileTagsResponse> | undefined): boolean {
    return proto3.util.equals(BatchGetProfileTagsResponse, a, b);
  }
}

/**
 * @generated from message gdx.profile.v1.GetHomelessProfileLocationRequest
 */
export class GetHomelessProfileLocationRequest extends Message<GetHomelessProfileLocationRequest> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string homeless_profile_id = 2;
   */
  homelessProfileId = "";

  constructor(data?: PartialMessage<GetHomelessProfileLocationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.profile.v1.GetHomelessProfileLocationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "homeless_profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetHomelessProfileLocationRequest {
    return new GetHomelessProfileLocationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetHomelessProfileLocationRequest {
    return new GetHomelessProfileLocationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetHomelessProfileLocationRequest {
    return new GetHomelessProfileLocationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetHomelessProfileLocationRequest | PlainMessage<GetHomelessProfileLocationRequest> | undefined, b: GetHomelessProfileLocationRequest | PlainMessage<GetHomelessProfileLocationRequest> | undefined): boolean {
    return proto3.util.equals(GetHomelessProfileLocationRequest, a, b);
  }
}

/**
 * @generated from message gdx.profile.v1.GetHomelessProfileLocationResponse
 */
export class GetHomelessProfileLocationResponse extends Message<GetHomelessProfileLocationResponse> {
  /**
   * @generated from field: gdx.common.v1.ProfileLocation location = 1;
   */
  location?: ProfileLocation;

  constructor(data?: PartialMessage<GetHomelessProfileLocationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.profile.v1.GetHomelessProfileLocationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "location", kind: "message", T: ProfileLocation },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetHomelessProfileLocationResponse {
    return new GetHomelessProfileLocationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetHomelessProfileLocationResponse {
    return new GetHomelessProfileLocationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetHomelessProfileLocationResponse {
    return new GetHomelessProfileLocationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetHomelessProfileLocationResponse | PlainMessage<GetHomelessProfileLocationResponse> | undefined, b: GetHomelessProfileLocationResponse | PlainMessage<GetHomelessProfileLocationResponse> | undefined): boolean {
    return proto3.util.equals(GetHomelessProfileLocationResponse, a, b);
  }
}

/**
 * @generated from message gdx.profile.v1.BatchGetHomelessProfileLocationRequest
 */
export class BatchGetHomelessProfileLocationRequest extends Message<BatchGetHomelessProfileLocationRequest> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: repeated string homeless_profile_id = 2;
   */
  homelessProfileId: string[] = [];

  constructor(data?: PartialMessage<BatchGetHomelessProfileLocationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.profile.v1.BatchGetHomelessProfileLocationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "homeless_profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetHomelessProfileLocationRequest {
    return new BatchGetHomelessProfileLocationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetHomelessProfileLocationRequest {
    return new BatchGetHomelessProfileLocationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetHomelessProfileLocationRequest {
    return new BatchGetHomelessProfileLocationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetHomelessProfileLocationRequest | PlainMessage<BatchGetHomelessProfileLocationRequest> | undefined, b: BatchGetHomelessProfileLocationRequest | PlainMessage<BatchGetHomelessProfileLocationRequest> | undefined): boolean {
    return proto3.util.equals(BatchGetHomelessProfileLocationRequest, a, b);
  }
}

/**
 * @generated from message gdx.profile.v1.BatchGetHomelessProfileLocationResponse
 */
export class BatchGetHomelessProfileLocationResponse extends Message<BatchGetHomelessProfileLocationResponse> {
  /**
   * @generated from field: map<string, gdx.common.v1.ProfileLocation> locations = 1;
   */
  locations: { [key: string]: ProfileLocation } = {};

  constructor(data?: PartialMessage<BatchGetHomelessProfileLocationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.profile.v1.BatchGetHomelessProfileLocationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "locations", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: ProfileLocation} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetHomelessProfileLocationResponse {
    return new BatchGetHomelessProfileLocationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetHomelessProfileLocationResponse {
    return new BatchGetHomelessProfileLocationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetHomelessProfileLocationResponse {
    return new BatchGetHomelessProfileLocationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetHomelessProfileLocationResponse | PlainMessage<BatchGetHomelessProfileLocationResponse> | undefined, b: BatchGetHomelessProfileLocationResponse | PlainMessage<BatchGetHomelessProfileLocationResponse> | undefined): boolean {
    return proto3.util.equals(BatchGetHomelessProfileLocationResponse, a, b);
  }
}

/**
 * @generated from message gdx.profile.v1.GetUserIDRequest
 */
export class GetUserIDRequest extends Message<GetUserIDRequest> {
  /**
   * @generated from field: string email = 1;
   */
  email = "";

  constructor(data?: PartialMessage<GetUserIDRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.profile.v1.GetUserIDRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUserIDRequest {
    return new GetUserIDRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUserIDRequest {
    return new GetUserIDRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUserIDRequest {
    return new GetUserIDRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetUserIDRequest | PlainMessage<GetUserIDRequest> | undefined, b: GetUserIDRequest | PlainMessage<GetUserIDRequest> | undefined): boolean {
    return proto3.util.equals(GetUserIDRequest, a, b);
  }
}

/**
 * @generated from message gdx.profile.v1.GetUserIDResponse
 */
export class GetUserIDResponse extends Message<GetUserIDResponse> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<GetUserIDResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.profile.v1.GetUserIDResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUserIDResponse {
    return new GetUserIDResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUserIDResponse {
    return new GetUserIDResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUserIDResponse {
    return new GetUserIDResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetUserIDResponse | PlainMessage<GetUserIDResponse> | undefined, b: GetUserIDResponse | PlainMessage<GetUserIDResponse> | undefined): boolean {
    return proto3.util.equals(GetUserIDResponse, a, b);
  }
}

/**
 * @generated from message gdx.profile.v1.GetProfileInfoRequest
 */
export class GetProfileInfoRequest extends Message<GetProfileInfoRequest> {
  /**
   * If empty user_id will be taken from current context. Request context should be authorized.
   *
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<GetProfileInfoRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.profile.v1.GetProfileInfoRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProfileInfoRequest {
    return new GetProfileInfoRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProfileInfoRequest {
    return new GetProfileInfoRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProfileInfoRequest {
    return new GetProfileInfoRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetProfileInfoRequest | PlainMessage<GetProfileInfoRequest> | undefined, b: GetProfileInfoRequest | PlainMessage<GetProfileInfoRequest> | undefined): boolean {
    return proto3.util.equals(GetProfileInfoRequest, a, b);
  }
}

/**
 * @generated from message gdx.profile.v1.GetProfileInfoResponse
 */
export class GetProfileInfoResponse extends Message<GetProfileInfoResponse> {
  /**
   * @generated from field: gdx.common.v1.ProfileInfo profile = 1;
   */
  profile?: ProfileInfo;

  constructor(data?: PartialMessage<GetProfileInfoResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.profile.v1.GetProfileInfoResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "profile", kind: "message", T: ProfileInfo },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProfileInfoResponse {
    return new GetProfileInfoResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProfileInfoResponse {
    return new GetProfileInfoResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProfileInfoResponse {
    return new GetProfileInfoResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetProfileInfoResponse | PlainMessage<GetProfileInfoResponse> | undefined, b: GetProfileInfoResponse | PlainMessage<GetProfileInfoResponse> | undefined): boolean {
    return proto3.util.equals(GetProfileInfoResponse, a, b);
  }
}

